<template>
  <Toast/>
  <div class="card mb-4 pt-3">
<div class="card-header pb-0">
<h6>Add New Admin</h6>
</div>
<div class="card-body mt-4">
  <form @submit.prevent="addAdmin" class="py-4">
  <div class="row mb-3 ms-4">
  <label class="col-sm-1 col-form-label">Name</label>
  <div class="col-sm-10">
    <input name="name" type="text" class="form-control" placeholder="Enter New Admin Name" v-model="name" required>
  </div>
</div>

<div class="row mb-3 ms-4">
  <label class="col-sm-1 col-form-label">Phone</label>
  <div class="col-sm-10">
    <input type="number" class="form-control" placeholder="Enter New Admin Phone" v-model="phone" required>
  </div>
</div>

<div class="row mb-3 ms-4">
  <label class="col-sm-1 col-form-label">Email</label>
  <div class="col-sm-10">
    <input type="email" class="form-control" placeholder="Enter New Admin Name" v-model="email" required>
  </div>
</div>

<div class="row mb-3 ms-4">
  <label class="col-sm-1 col-form-label">Password</label>
  <div class="col-sm-10">
    <input type="password" class="form-control" placeholder="Enter New Admin Password" v-model="password" required>
  </div>
</div>

<div class="d-grid gap-2 mt-5">
  <button class="btn btn-primary mx-11" type="submit">Submit</button>
</div>

</form>

</div>
</div>
</template>

<script>
import AdminService from '../service/AdminService';
import Toast from 'primevue/toast';

export default {

  name: "add-admin" ,
  components : {
    Toast 
  },
  data(){
    return {
      name : null ,
      email : null,
      password : null,
      phone : null, 
      adminService : null ,
    }
  },
  created() {
    this.adminService = new AdminService();
  },
  methods : {
    addAdmin(){
      if(this.name &&  this.email && this.phone && this.password){
        this.adminService.addAdmin(this.name , this.email ,this.phone , this.password).then((data)=>{
          console.log(data)
            this.name = null ;
            this.email = null ;
            this.phone = null ;
            this.password = null ;
            this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Subscription Updated",
        life: 3000,});
        })
      }
  },
}
}
</script>
